(function () {
'use strict';

angular
    .module('riskEditRoutes', [
        'riskEditModule'
    ])
    .config(router);

    router.$inject = ['$stateProvider', 'historyCtxtServiceProvider'];

    function router($stateProvider, historyCtxtServiceProvider) {

        $stateProvider

             // Risk not exists
             .state('riskNotExists', {
                 url: '/Risk/{RiskID:int}/NotExists',
                 templateUrl: require('./riskNotExists.tpl.html')
             })

             // Add Risk
             .state('riskTopAdd', {
                 url: '/Risk/Add',
                 resolve: {
                     governanceProcess: ['grcGovernanceProcessService', function (service) {
                         return service.getActiveRiskSelfAssessments();
                     }],
                     riskLevels: ['grcRiskService', function (service) {
                         return service.getAllRiskLevels();
                     }],
                     riskLevel: ['riskLevels', function (riskLevels) {
                         return _.find(riskLevels,  {Value: 'Top'});
                     }],
                     risk: ['riskLevel', function (riskLevel) {
                         return {
                             RiskLevelID: riskLevel.RiskLevelID,
                             RiskLevel: riskLevel,
                         };
                     }]
                 },
                 templateUrl: require('./riskEdit.tpl.html'),
                 controller: 'RiskEditController',
             })

             .state('riskKeyOrDeptAdd', {
                 url: '/Risk/{RiskLevelValue}/ForParentRisk/{ParentRiskID:int}/Add',
                 resolve: {
                     governanceProcess: ['grcGovernanceProcessService', function (service) {
                         return service.getActiveRiskSelfAssessments();
                     }],
                     riskLevels: ['grcRiskService', function (service) {
                         return service.getAllRiskLevels();
                     }],
                     riskLevel: ['$stateParams', 'riskLevels', function ($stateParams, riskLevels) {
                         return _.find(riskLevels, { Value: $stateParams.RiskLevelValue });
                     }],
                     parentRiskToAssociate: ['$stateParams', 'grcRiskService', function ($stateParams, service) {
                         return service.getRisk($stateParams.ParentRiskID);
                     }],
                     risk: ['$stateParams', 'riskLevel', 'parentRiskToAssociate', function ($stateParams, riskLevel, parentRiskToAssociate) {
                         var hierarchyRisks = _.clone(parentRiskToAssociate.HierarchyRisks);
                         hierarchyRisks.push(parentRiskToAssociate);

                         return {
                             ParentRiskID: $stateParams.ParentRiskID,
                             HierarchyRisks: hierarchyRisks,
                             RiskLevelID: riskLevel.RiskLevelID,
                             RiskLevel: riskLevel,
                         };
                     }]
                 },
                 templateUrl: require('./riskEdit.tpl.html'),
                 controller: 'RiskEditController',
             })

             // Edit Risk
             .state('riskEdit', {
                 url: '/Risk/{RiskID:int}',
                 params: historyCtxtServiceProvider.getStateParamsConfig(),
                 resolve: {
                     risk: ['$stateParams', 'grcRiskService', function ($stateParams, service) {
                         return service.getRisk($stateParams.RiskID);
                     }]
                 },
                 views: {
                     '': {
                         template: '<div ui-view="mainContent"></div>',
                         controller: 'RiskEditController'
                     },
                     'mainContent@riskEdit': {
                         templateUrl: require('./riskEdit.tpl.html')
                     }
                 }
             })

             // Sub Risks
             .state('riskEdit.SubRisks', {
                 url: '/SubRisk',
                 resolve: {
                     subRisks: ['$stateParams', 'grcRiskService', function ($stateParams, service) {
                         return service.getSubRisks($stateParams.RiskID);
                     }]
                 },
                 views: {
                     'mainContent@riskEdit': {
                         templateUrl: require('./riskSubRisks.tpl.html'),
                         controller: 'RiskSubRisksController'
                     }
                 }
             })

             // Related Controls
             .state('riskEdit.RelatedControls', {
                 url: '/Control',
                 resolve: {
                     controls: ['$stateParams', 'grcRiskService', function ($stateParams, service) {
                         return service.getRelatedControls($stateParams.RiskID);
                     }]
                 },
                 views: {
                     'mainContent@riskEdit': {
                         templateUrl: require('./riskRelatedControls.tpl.html'),
                         controller: 'RiskRelatedControlsController'
                     }
                 }
             })

                // Related Risk Events
             .state('riskEdit.RelatedRiskEvents', {
                 url: '/RiskEvent',
                 resolve: {
                     relatedRiskEvents: ['$stateParams', 'grcRiskService', function ($stateParams, service) {
                         return service.getRelatedRiskEvents($stateParams.RiskID);
                     }]
                 },
                 views: {
                     'mainContent@riskEdit': {
                         templateUrl: require('./riskRelatedRiskEvents.tpl.html'),
                         controller: 'RiskRelatedRiskEventsController'
                     }
                 }
             })

             // History Risk
             .state('riskEdit.History', {
                 url: '/History',
                 resolve: {
                     historicRecords: ['$stateParams', 'grcRiskService', function ($stateParams, service) {
                         return service.getHistoricOnRisk($stateParams.RiskID);
                     }]
                 },
                 views: {
                     'mainContent@riskEdit': {
                         templateUrl: require('./viewHistoryOnRisk.tpl.html'),
                         controller: 'ViewHistoricOnRiskController'
                     }
                 }
             });

        historyCtxtServiceProvider.setCtxtState('riskEdit',
            '/app/Main/grcEdit/risk/GOVHistoryCtxtDirective-riskEdit.tpl.html'
        );
    }
})();
